import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  Card,
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import { Navigate } from "react-router-dom";

export default class UpdateBlogs extends Component {
  state = {
    blogId: "",

    blog_category: "",
    blogs_title: "",
    blog_tags: "",
    blog_content: "",
    status: "inactive",

    blogs_poster: null,
    existing_poster: "",

    allCategories: [],

    loading: false,
    notification: false,
    notiColor: "success",
    message: "",
    redirect: false,
  };

  componentDidMount() {
    const blogId = window.location.pathname.split("/")[2];
    this.setState({ blogId }, () => {
      this.getAllBlogCategories();
      this.getSingleBlog(blogId);
    });
  }

  /* =========================
     FETCH BLOG
  ========================= */
  getSingleBlog = async (id) => {
    if (init() !== "success") return this.setState({ redirect: true });

    try {
      const res = await axios.get(
        Constants.getUrls.getAllBlogs + "/" + id
      );

      const b = res.data.data;

      this.setState({
        blogs_title: b.blogs_title || "",
        blog_category: b.blog_category?._id || "",
        blog_tags: b.blog_tags || "",
        blog_content: b.blog_content || "",
        status: b.status || "inactive",
        existing_poster: b.blogs_poster || "",
      });
    } catch {
      this.showSnackbar("error", "Failed to load blog");
    }
  };

  /* =========================
     FETCH CATEGORIES
  ========================= */
  getAllBlogCategories = async () => {
    try {
      const res = await axios.get(
        `${Constants.getUrls.getAllBlogCategories}?limit=100`
      );
      this.setState({ allCategories: res.data.data });
    } catch {
      this.showSnackbar("error", "Failed to load categories");
    }
  };

  /* =========================
     HELPERS
  ========================= */
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  showSnackbar = (color, message) => {
    this.setState({ notification: true, notiColor: color, message });
    setTimeout(() => {
      this.setState({ notification: false, message: "" });
    }, 3000);
  };

  /* =========================
     SUBMIT
  ========================= */
  handleSubmit = async (e) => {
    e.preventDefault();
    if (init() !== "success") return;

    const fd = new FormData();
    fd.append("blogs_title", this.state.blogs_title);
    fd.append("blog_category", this.state.blog_category);
    fd.append("blog_tags", this.state.blog_tags);
    fd.append("blog_content", this.state.blog_content);
    fd.append("status", this.state.status);

    if (this.state.blogs_poster) {
      fd.append("blogs_poster", this.state.blogs_poster);
    }

    try {
      this.setState({ loading: true });

      await axios.put(
        Constants.putUrls.updateBlogs + this.state.blogId,
        fd
      );

      this.showSnackbar("success", "Blog updated successfully");
      setTimeout(() => this.setState({ redirect: true }), 2000);
    } catch (err) {
      this.showSnackbar(
        "error",
        err?.response?.data?.message || "Update failed"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  /* =========================
     RENDER
  ========================= */
  render() {
    if (this.state.redirect) return <Navigate to="/blogs" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Blog
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* TITLE */}
                  <Grid item sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Blog Title"
                      name="blogs_title"
                      value={this.state.blogs_title}
                      onChange={this.handleChange}
                    />
                  </Grid>

                  {/* TAGS */}
                  <Grid item sm={6}>
                    <TextField
                      fullWidth
                      label="Blog Tags"
                      name="blog_tags"
                      value={this.state.blog_tags}
                      onChange={this.handleChange}
                    />
                  </Grid>

                  {/* CATEGORY */}
                  <Grid item sm={6}>
                    <InputLabel sx={{ mb: 1 }}>
                      Blog Category
                    </InputLabel>
                    <Select
                      fullWidth
                      required
                      name="blog_category"
                      value={this.state.blog_category}
                      onChange={this.handleChange}
                      sx={{ height: "45px" }}
                    >
                      <MenuItem value="">Select Category</MenuItem>
                      {this.state.allCategories.map((cat) => (
                        <MenuItem key={cat._id} value={cat._id}>
                          {cat.category}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  {/* STATUS */}
                  <Grid item sm={6}>
                    <InputLabel sx={{ mb: 1 }}>
                      Status
                    </InputLabel>
                    <Select
                      fullWidth
                      name="status"
                      value={this.state.status}
                      onChange={this.handleChange}
                      sx={{ height: "45px" }}
                    >
                      <MenuItem value="inactive">Inactive</MenuItem>
                      <MenuItem value="active">Active</MenuItem>
                    </Select>
                  </Grid>

                  {/* EXISTING POSTER */}
                  {this.state.existing_poster && (
                    <Grid item sm={6}>
                      <MDTypography variant="button">
                        Current Poster
                      </MDTypography>
                      <br />
                      <img
                        src={Constants.imageDomain + this.state.existing_poster}
                        alt="Poster"
                        style={{
                          height: 80,
                          width: 160,
                          objectFit: "cover",
                          marginTop: 6,
                        }}
                      />
                    </Grid>
                  )}

                  {/* NEW POSTER */}
                  <Grid item sm={6}>
                    <TextField
                      type="file"
                      label="Replace Poster"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({ blogs_poster: e.target.files[0] })
                      }
                    />
                  </Grid>

                  {/* CONTENT */}
                  <Grid item sm={12}>
                    <MDTypography mb={1}>
                      Blog Content
                    </MDTypography>

                    <SunEditor
                      setContents={this.state.blog_content}
                      onChange={(content) =>
                        this.setState({ blog_content: content })
                      }
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["undo", "redo"],
                          ["bold", "underline", "italic"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link"],
                          ["removeFormat"],
                        ],
                      }}
                    />
                  </Grid>

                </Grid>

                <MDBox mt={3}>
                  <MDButton
                    type="submit"
                    color="info"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Updating..." : "Update Blog"}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Blogs Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
